(function(){
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* BOOT */
  const boot = document.getElementById('boot');
  const lines = document.querySelectorAll('#terminal .line');
  const seal = document.getElementById('bootSeal');
  const eye = document.getElementById('eye');
  const skipBtn = document.getElementById('skipBoot');
  function reveal() {
    if (!boot) return;
    boot.classList.add('done');
    if (eye) eye.classList.add('revealed');
    document.body.style.overflow = '';
  }
  function runBoot() {
    if (!boot) return;
    if (reduced) { reveal(); return; }
    document.body.style.overflow = 'hidden';
    boot.classList.add('warmup');
    setTimeout(() => boot.classList.remove('warmup'), 1200);
    let i = 0;
    function step() {
      if (i >= lines.length) {
        if (seal) seal.classList.add('in');
        setTimeout(reveal, 900);
        return;
      }
      lines[i].style.transition = 'opacity 320ms ease';
      lines[i].style.opacity = '1';
      i++;
      setTimeout(step, 380);
    }
    setTimeout(step, 850);
  }
  if (skipBtn) skipBtn.addEventListener('click', reveal);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' || e.key === 'Enter') reveal(); }, { once: true });
  if (boot) {
    if (sessionStorage.getItem('poa_booted') === '1') { reveal(); }
    else { sessionStorage.setItem('poa_booted', '1'); runBoot(); }
    // Failsafe: kill boot after 5s no matter what
    setTimeout(reveal, 5000);
  }

  /* NAV TINT */
  const nav = document.getElementById('nav');
  const terra = document.getElementById('terra');
  const dark = [eye, terra].filter(Boolean);
  function tintNav() {
    if (!nav) return;
    const navH = nav.getBoundingClientRect().bottom;
    let onDark = false;
    dark.forEach(s => {
      const r = s.getBoundingClientRect();
      if (r.top < navH && r.bottom > navH) onDark = true;
    });
    nav.classList.toggle('on-dark', onDark);
  }
  window.addEventListener('scroll', tintNav, { passive: true });
  tintNav();

  /* SECTION REVEAL */
  if ('IntersectionObserver' in window && !reduced) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('in-view'));
  }
  // Always force in-view as failsafe
  setTimeout(() => {
    document.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('in-view'));
  }, 800);

  /* MAGNETIC BUTTONS */
  if (finePointer && !reduced) {
    document.querySelectorAll('.cta, .access, .nav .actions a').forEach(btn => {
      const strength = 8;
      btn.addEventListener('mousemove', (ev) => {
        const r = btn.getBoundingClientRect();
        const dx = (ev.clientX - r.left - r.width/2) / r.width * strength * 2;
        const dy = (ev.clientY - r.top - r.height/2) / r.height * strength * 2;
        btn.style.transform = `translate3d(${dx}px, ${dy}px, 0)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* COORDINATE TICKER */
  const coordD = document.querySelector('[data-coord-d]');
  const coordE = document.querySelector('[data-coord-e]');
  if (coordD && coordE && !reduced) {
    let dVal = 1, eVal = 4, dDir = 1, eDir = -1;
    setInterval(() => {
      if (Math.random() < 0.35) {
        dVal += dDir;
        if (dVal >= 9) { dVal = 9; dDir = -1; }
        if (dVal <= 0) { dVal = 0; dDir = 1; }
        coordD.textContent = dVal;
      }
      if (Math.random() < 0.35) {
        eVal += eDir;
        if (eVal >= 9) { eVal = 9; eDir = -1; }
        if (eVal <= 0) { eVal = 0; eDir = 1; }
        coordE.textContent = eVal;
      }
    }, 1200);
  }

  /* RAIL ARROWS */
  const track = document.getElementById('railTrack');
  const railPrev = document.getElementById('railPrev');
  const railNext = document.getElementById('railNext');
  if (track && railPrev) railPrev.addEventListener('click', (e) => { e.preventDefault(); track.scrollBy({ left: -track.clientWidth * 0.6, behavior: 'smooth' }); });
  if (track && railNext) railNext.addEventListener('click', (e) => { e.preventDefault(); track.scrollBy({ left:  track.clientWidth * 0.6, behavior: 'smooth' }); });

  /* TERRA BG PRELOAD */
  if (terra) {
    const terraImgs = ['assets/terra-bg-base.jpg', 'assets/terra-bg-bloom.png', 'assets/terra-bg-embers.png'];
    Promise.all(terraImgs.map(src => new Promise(res => {
      const img = new Image();
      img.onload = img.onerror = () => res();
      img.src = src;
    }))).then(() => {
      setTimeout(() => terra.classList.add('bg-loaded'), 80);
    });
  }

  /* HEADLINE TYPE-SET */
  function buildTypeset(el) {
    if (el.dataset.typesetReady) return;
    const html = el.innerHTML;
    const out = [];
    const parts = html.split(/(<br\s*\/?>)/i);
    let charIndex = 0;
    parts.forEach(part => {
      if (/^<br/i.test(part)) { out.push(part); return; }
      const tmp = document.createElement('div');
      tmp.innerHTML = part;
      const text = tmp.textContent;
      for (const ch of text) {
        if (ch === ' ') { out.push('<span class="ch space">&nbsp;</span>'); }
        else { out.push(`<span class="ch" style="transition-delay:${charIndex * 22}ms">${ch}</span>`); charIndex++; }
      }
    });
    el.innerHTML = `<span class="typeset-mask"><span class="typeset">${out.join('')}</span></span>`;
    el.dataset.typesetReady = '1';
  }
  if ('IntersectionObserver' in window && !reduced) {
    const tio = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          buildTypeset(e.target);
          setTimeout(() => e.target.querySelectorAll('.ch').forEach(ch => ch.classList.add('in')), 400);
          tio.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-typeset]').forEach(el => tio.observe(el));
  }

  /* CART DRAWER (uses real Shopify cart, not local mock) */
  /* CART DRAWER */
const drawer = document.getElementById('cart-drawer');
const scrim  = document.getElementById('cart-scrim');
const cartOpenLink  = document.getElementById('cartOpen');
const cartCloseBtn = document.getElementById('cartClose');
function openCart() {
  if (!drawer) return;
  drawer.classList.add('open');
  if (scrim) scrim.classList.add('visible');
  drawer.setAttribute('aria-hidden', 'false');
}
function closeCart() {
  if (!drawer) return;
  drawer.classList.remove('open');
  if (scrim) scrim.classList.remove('visible');
  drawer.setAttribute('aria-hidden', 'true');
}
if (cartOpenLink) cartOpenLink.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
if (scrim) scrim.addEventListener('click', closeCart);
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeCart(); });

/* AJAX ADD TO CART */
const caseFileForm = document.getElementById('caseFileForm');
if (caseFileForm) {
  caseFileForm.addEventListener('submit', function(e) {
    e.preventDefault();
    const variantInput = caseFileForm.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) return;
    const btn = caseFileForm.querySelector('button[type="submit"]');
    if (btn) btn.setAttribute('disabled', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantInput.value, quantity: 1 })
    })
    .then(res => res.json())
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => {
      const total = document.getElementById('cartTotal');
      if (total) total.textContent = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      const count = document.getElementById('cartCount');
      if (count) count.textContent = cart.item_count;
      openCart();
    })
    .catch(err => console.error('Cart error:', err))
    .finally(() => { if (btn) btn.removeAttribute('disabled'); });
  });
}

  /* PDP size + thumb selection (visual state only — form submission is real Shopify) */
  document.querySelectorAll('.case-file .sz:not(.out)').forEach(sz => {
    sz.addEventListener('click', (e) => {
      // labels with hidden radio inputs — let the input toggle naturally, just visually mark
      document.querySelectorAll('.case-file .sz').forEach(s => s.classList.remove('active'));
      sz.classList.add('active');
    });
  });
  document.querySelectorAll('.case-file .thumb').forEach(t => {
    t.addEventListener('click', () => {
      document.querySelectorAll('.case-file .thumb').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      const newSrc = t.getAttribute('data-image');
      const main = document.getElementById('caseFileMainImg');
      if (newSrc && main) main.src = newSrc;
    });
  });

  /* DROP TIMER (only if a target attribute exists on the timer element) */
  const timer = document.getElementById('dropTimer');
  if (timer) {
    const targetStr = timer.getAttribute('data-target');
    if (targetStr) {
      const targetDate = new Date(targetStr);
      const elD = timer.querySelector('[data-d]');
      const elH = timer.querySelector('[data-h]');
      const elM = timer.querySelector('[data-m]');
      const elS = timer.querySelector('[data-s]');
      function tick() {
        const ms = targetDate - new Date();
        if (ms <= 0) { elD.textContent = elH.textContent = elM.textContent = elS.textContent = '00'; return; }
        elD.textContent = String(Math.floor(ms / 86400000)).padStart(2,'0');
        elH.textContent = String(Math.floor(ms % 86400000 / 3600000)).padStart(2,'0');
        elM.textContent = String(Math.floor(ms % 3600000 / 60000)).padStart(2,'0');
        elS.textContent = String(Math.floor(ms % 60000 / 1000)).padStart(2,'0');
      }
      tick(); setInterval(tick, 1000);
    }
  }

  /* KONAMI POA UNLOCK */
  const sealedArchive = document.getElementById('sealed-archive');
  const archiveCloseBtn  = document.getElementById('archiveClose');
  const poaToast      = document.getElementById('poa-key-toast');
  let typed = '';
  if (archiveCloseBtn) archiveCloseBtn.addEventListener('click', () => {
    sealedArchive.classList.remove('open');
    document.body.style.overflow = '';
  });
  document.addEventListener('keydown', (ev) => {
    const tag = (ev.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || ev.target.isContentEditable) return;
    if (ev.key === 'Escape' && sealedArchive && sealedArchive.classList.contains('open')) {
      sealedArchive.classList.remove('open');
      document.body.style.overflow = '';
      return;
    }
    if (ev.key && ev.key.length === 1) {
      typed += ev.key.toUpperCase();
      if (typed.length > 3) typed = typed.slice(-3);
      if (typed === 'POA' && sealedArchive) {
        typed = '';
        sealedArchive.classList.add('open');
        document.body.style.overflow = 'hidden';
        if (poaToast) {
          poaToast.classList.add('show');
          setTimeout(() => poaToast.classList.remove('show'), 1800);
        }
      }
    }
  });
})();